import type { SubscriptionTier } from '../types/platformOrganization';

export const TIER_ORDER: SubscriptionTier[] = ['BASIC', 'PROFESSIONAL', 'PREMIUM'];

export function tierRank(tier: string): number {
  const i = TIER_ORDER.indexOf(tier as SubscriptionTier);
  return i < 0 ? -1 : i;
}

export function isHigherTier(candidate: string, current: string): boolean {
  return tierRank(candidate) > tierRank(current);
}
